/**
 * Type guard to check if a value is a valid number (finite, not NaN).
 * Replicated from visx internal utilities.
 */
export function isValidNumber(numberToCheck: unknown): numberToCheck is number {
  const numberToCheckIsDefined = numberToCheck !== null && numberToCheck !== undefined;
  return (
    numberToCheckIsDefined &&
    typeof numberToCheck === 'number' &&
    !Number.isNaN(numberToCheck) &&
    Number.isFinite(numberToCheck)
  );
}
